import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { PageEnum } from '@/enums/pageEnum';

const schoolCompetition: AppRouteModule = {
    path: '/schoolCompetition',
    name: PageEnum.SCHOOL_COMPETITION,
    component: LAYOUT,
    redirect: '/schoolCompetition/index',
    meta: {
        orderNo: 15,
        icon: 'championships',
        title: '网校网赛',
        /** 是否有等级分限制 */
        scoreLimit: true,
        /** 赛事类型 1：锦标赛，2：战力赛，3：网校网赛 */
        type: 3,
        /** 大厅页 */
        homePageName: 'SchoolCompetitionIndex',
        /** 赛事详情页 */
        detailsPageName: PageEnum.SCHOOL_COMPETITION_DETAILS,
        /** 游戏页 */
        gamePageName: PageEnum.SCHOOL_COMPETITION_GAME,
    },
    children: [
        {
            path: 'index',
            name: 'SchoolCompetitionIndex',
            component: () => import('@/views/menu/championships/index.vue'),
            meta: {
                title: '网校网赛',
            },
        },
        {
            path: 'details',
            name: PageEnum.SCHOOL_COMPETITION_DETAILS,
            component: () => import('@/views/menu/championships/competition-details/index.vue'),
            meta: {
                title: '网校网赛',
            },
        },
        {
            path: 'game',
            name: PageEnum.SCHOOL_COMPETITION_GAME,
            component: () => import('@/views/menu/championships/game/index.vue'),
            meta: {
                title: '网校网赛',
            },
        },
    ],
};

export default schoolCompetition;
